import React from 'react';
import './WorkSection';

function WorkSection() {
    return (
        <div className="container">
            <div className="row">
                <div className="work">
                    <div className="col-md-6 mx-auto">
                        <div className="work_top">
                            <h1>
                                Dhar <span>Manager</span> works well
                            </h1>
                        </div>
                    </div>
                    <div className="col-md-4 mx-auto">
                        <div className="work_text">
                            <p>
                                Ready to see the incredible achievements of Our HR Solutions? Take
                                a Sneak Peek Now at Our Achievement collated videos!
                            </p>
                            <div className="work_img">
                                <img src="/images/dhart/imageasvideo.jpg" alt="picture" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WorkSection;
